import { navigate } from '../router.ts';

/** /legal: what retrowser is and isn't. Plain text, no game names or marks. */
export function Legal() {
  return (
    <main class="legal">
      <nav><a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }}>← retrowser</a></nav>
      <h1>Legal notice</h1>

      <h2>What retrowser is</h2>
      <p>
        retrowser is a loader. You give it the link to a third-party GitHub repository; it downloads that repository's
        own web build, checks it against the fingerprints the repository publishes, and runs it in a sandbox in your
        browser. Any list of games shown here is a catalogue of links to those independent projects.
      </p>

      <h2>What retrowser does not provide</h2>
      <ul>
        <li>No game code. Game code is fetched directly from the linked repository (raw.githubusercontent.com) and is
          never stored on or served from retrowser's servers.</li>
        <li>No ROMs, BIOS files, game assets or other copyrighted game data. retrowser does not host, link to or help
          obtain them.</li>
        <li>No upload of your files. The ROM you choose is read on your device and passed only into the game's sandbox,
          which has no network access. It is never sent to retrowser or anyone else.</li>
      </ul>

      <h2>Online play</h2>
      <p>
        Games that support it can be played online with other people. Your browser then connects directly to theirs
        (WebRTC), so <strong>the other players can see your IP address</strong>, and you theirs; play only with people
        you trust. retrowser's room server only passes the connection set-up (session descriptions and network
        candidates, which also contain IP addresses) between the players in a room, keeps nothing once the room
        closes (when the game starts, or after 10 minutes), and never carries game data. Public STUN servers
        (Google, Cloudflare) see your IP address when your browser asks them for its public address.
      </p>

      <h2>Your responsibility</h2>
      <p>
        Use only ROMs you are legally entitled to use, such as a dump of a cartridge you own, where the law of your
        country allows it. Whether a given project or use is lawful where you live is for you to check.
      </p>

      <h2>Third-party projects</h2>
      <p>
        Each project is written, published and licensed by its own authors, under the licence stated in its
        repository. retrowser does not write, review, endorse or control them, and is not responsible for their
        content or behaviour. Questions or complaints about a project belong with its authors.
      </p>

      <h2>No affiliation</h2>
      <p>
        retrowser is not affiliated with, endorsed by or sponsored by any console maker, game developer or publisher.
        All product names, trademarks and registered trademarks belong to their respective owners and are used only
        to identify the projects they describe.
      </p>

      <h2>No warranty</h2>
      <p>
        retrowser is provided "as is", without warranty of any kind, under the MIT licence. Saves and other data are
        kept in your browser; keep your own copies (Export save) of anything that matters to you.
      </p>
    </main>
  );
}

/** One line under every host page. */
export function LegalFooter() {
  return (
    <footer class="legal-footer muted">
      retrowser hosts no game code, ROMs or game assets: it runs third-party open-source projects from their own
      repositories in your browser, with your own ROM.{' '}
      <a href="/legal" onClick={(e) => { e.preventDefault(); navigate('/legal'); }}>Legal notice</a>
    </footer>
  );
}
